import { Text, View, StyleSheet } from "@react-pdf/renderer";
import { Tab } from "../../types/AlgoliaTypes";

interface TableRowProps {
    items: Tab
}

const styles = StyleSheet.create({
    row: {
        flexDirection: "row",
        alignItems: "center"
    },
    title: {
        width: "100%",
        paddingBottom: 4,
        fontFamily: "Helvetica-Bold",
        fontSize: "9.5pt",
        borderColor: "#e0e0e0",
        borderWidth: 1,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        borderRightWidth: 0,
        borderStyle: "solid",
    },
    key: {
        width: "40%",
        height: 20,
        paddingVertical: 4,
        fontFamily: "Helvetica-Bold",
        fontSize: "9pt",
        borderColor: "#e0e0e0",
        borderWidth: 1,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        borderRightWidth: 0,
        borderStyle: "solid"
    },
    data: {
        width: "60%",
        height: 20,
        paddingVertical: 4,
        fontFamily: "Helvetica",
        fontSize: "8.5pt",
        borderColor: "#e0e0e0",
        borderWidth: 1,
        borderTopWidth: 0,
        borderLeftWidth: 0,
        borderRightWidth: 0,
        borderStyle: "solid",
        color: "#4d4d4d"
    }
})

export default function TableRow({items}: TableRowProps) {
    return (
        <>
            <Text style={[styles.title]}>{items.tabTitle.toUpperCase()}</Text>
            {
                items.tabItems.map((item, idx) => {
                    return (
                        <View style={[styles.row]} key={idx}>
                            <Text style={[styles.key]}>{item.label}</Text>
                            <Text style={[styles.data]}>
                                {  
                                    (() => {
                                        if(item.label === "Brand" || item.label === "Global Availability" || item.label === "Material Type" || item.label === "Design" || item.label === "Application" || item.label === "Sustainability"){
                                            let arr = item.value as string[]
                                            return arr.join(", ")
                                        } else if (item.label === "Notes") {
                                            if(item.value == "Matching edgeband available"){
                                                // return <Link to="../finish">Matching edgeband available</Link>
                                            }
                                            
                                            return item.value
                                        } else if (item.label == "ACT") {
                                            let actIconPaths = item.value as string;
                                            return actIconPaths.split(",").map((item) => {
                                                return <span className={`finish-details__tabs-data--act-icon finish-details__tabs-data--${item}`} />
                                            })
                                        } else {
                                            return item.value
                                        }
                                    })()  
                                }
                            </Text>
                        </View>
                    )
                })
            }
        </>
    )
}